import { db, Document } from './bases';
function handleError(error: any, operation: string): never {
  operation;
  throw error;
}

/**
 * Insert a new document into the database.
 *
 * @param doc       Document to be stored.
 * @param customDb  Optional Dexie instance to override the default one.
 * @returns The id of the created document.
 */
export async function createDocument(doc: Document, customDb?: any): Promise<number | undefined> {
  try {
    const dbInstance = customDb || db;
    const id = await dbInstance.documents.add(doc);
    return id;
  } catch (err) {
    handleError(err, 'creando documento');
  }
}

/**
 * Retrieve a document by its identifier.
 *
 * @param docId     Identifier of the document.
 * @param customDb  Optional Dexie instance to override the default one.
 * @returns The found document.
 */
export async function readDocumentById(docId: number, customDb?: any): Promise<Document> {
  try {
    const dbInstance = customDb || db;
    const doc = await dbInstance.documents.get(docId);
    if (doc) {

      return doc;
    } else {
      throw new Error(`Documento con ID ${docId} no encontrado`);
    }
  } catch (err) {
    handleError(err, `leyendo documento con ID ${docId}`);
  }
}

/**
 * Update a document's fields based on its id.
 *
 * @param docId        Identifier of the document to update.
 * @param updatedFields Fields to update in the document.
 * @param customDb      Optional Dexie instance to override the default one.
 */
export async function updateDocumentById(docId: number, updatedFields: Partial<Document>, customDb?: any): Promise<void> {
  try {
    const dbInstance = customDb || db;
    await dbInstance.documents.update(docId, updatedFields);
  } catch (err) {
    handleError(err, `actualizando documento con ID ${docId}`);
  }
}

/**
 * Remove a document from the database.
 *
 * @param docId    Identifier of the document to delete.
 * @param customDb Optional Dexie instance to override the default one.
 */
export async function deleteDocument(docId: number, customDb?: any): Promise<void> {
  try {
    const dbInstance = customDb || db;

    await dbInstance.documents.delete(docId);
 
  } catch (err) {
    handleError(err, `eliminando documento con ID ${docId}`);
  }
}
